import React, { useEffect, useState } from "react";
import "./DiscoveryCallBooking.css";

const API_BASE_URL = "/api";

const DiscoveryCallBooking = () => {
  useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, []);
    useEffect(() => {
        const navbar = document.querySelector("header, .navbar");
        const footer = document.querySelector("footer");
    
        if (navbar) navbar.style.display = "none";
        if (footer) footer.style.display = "none";
    
        return () => {
          if (navbar) navbar.style.display = "";
          if (footer) footer.style.display = "";
        };
      }, []);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [currentMonth, setCurrentMonth] = useState(
    new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    )
  );

  const [selectedDate, setSelectedDate] = useState("");
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [loadingSlots, setLoadingSlots] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  /* =========================
     DATE
  ========================= */

  const formatDateValue = (date) => {
    const year = date.getFullYear();

    const month = String(
      date.getMonth() + 1
    ).padStart(2, "0");

    const day = String(
      date.getDate()
    ).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const formatSelectedDate = () => {
    if (!selectedDate) return "";

    const date = new Date(
      `${selectedDate}T12:00:00`
    );

    return date.toLocaleDateString(
      "en-IN",
      {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
      }
    );
  };

  const monthTitle =
    currentMonth.toLocaleDateString(
      "en-US",
      {
        month: "long",
        year: "numeric"
      }
    );

  /* =========================
     CALENDAR
  ========================= */

  const getCalendarDays = () => {
    const year =
      currentMonth.getFullYear();

    const month =
      currentMonth.getMonth();

    const firstDay =
      new Date(
        year,
        month,
        1
      ).getDay();

    const daysInMonth =
      new Date(
        year,
        month + 1,
        0
      ).getDate();

    const mondayOffset =
      (firstDay + 6) % 7;

    const days = [];

    for (
      let i = 0;
      i < mondayOffset;
      i++
    ) {
      days.push(null);
    }

    for (
      let day = 1;
      day <= daysInMonth;
      day++
    ) {
      days.push(
        new Date(
          year,
          month,
          day
        )
      );
    }

    return days;
  };

  const isPastDate = (date) => {
    if (!date) return true;

    const checkDate =
      new Date(date);

    checkDate.setHours(
      0,
      0,
      0,
      0
    );

    return checkDate < today;
  };

  const isWeekend = (date) => {
    if (!date) return true;

    const day =
      date.getDay();

    return (
      day === 0 ||
      day === 6
    );
  };
  /* =========================
   WEEKLY BOOKING WINDOW
   ========================= */

// IMPORTANT:
// உன் Friday-யின் LAST SLOT முடியும் நேரத்தை இங்கே set பண்ணு.
// Example: last slot 5:00 PM - 5:15 PM என்றால் 17:15
const FRIDAY_SLOT_END_HOUR = 17;
const FRIDAY_SLOT_END_MINUTE = 15;

const getMonday = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);

  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;

  d.setDate(d.getDate() + diff);

  return d;
};

const getFriday = (date) => {
  const monday = getMonday(date);

  const friday = new Date(monday);
  friday.setDate(monday.getDate() + 4);

  friday.setHours(
    FRIDAY_SLOT_END_HOUR,
    FRIDAY_SLOT_END_MINUTE,
    0,
    0
  );

  return friday;
};

const isCurrentWeek = (date) => {
  if (!date) return false;

  const monday = getMonday(new Date());
  const nextMonday = new Date(monday);
  nextMonday.setDate(monday.getDate() + 7);

  const checkDate = new Date(date);
  checkDate.setHours(0, 0, 0, 0);

  return (
    checkDate >= monday &&
    checkDate < nextMonday
  );
};

const isNextWeek = (date) => {
  if (!date) return false;

  const monday = getMonday(new Date());

  const nextMonday = new Date(monday);
  nextMonday.setDate(monday.getDate() + 7);

  const weekAfterNext = new Date(monday);
  weekAfterNext.setDate(monday.getDate() + 14);

  const checkDate = new Date(date);
  checkDate.setHours(0, 0, 0, 0);

  return (
    checkDate >= nextMonday &&
    checkDate < weekAfterNext
  );
};

const isFridayBookingClosed = () => {
  const now = new Date();

  const fridayEnd = getFriday(now);

  return now >= fridayEnd;
};

const isBookableDate = (date) => {
  if (!date) return false;

  if (isPastDate(date)) return false;

  if (isWeekend(date)) return false;

  // Friday slot not finished yet
  if (!isFridayBookingClosed()) {
    // Only current week's dates are allowed
    return isCurrentWeek(date);
  }

  // Friday slots finished
  // Next week becomes available
  return isNextWeek(date);
};
  const isSelected = (date) => {
    if (
      !date ||
      !selectedDate
    ) {
      return false;
    }

    return (
      formatDateValue(date) ===
      selectedDate
    );
  };

  const goPreviousMonth = () => {
    const previous =
      new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth() - 1,
        1
      );

    const currentStart =
      new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );

    if (
      previous >=
      currentStart
    ) {
      setCurrentMonth(
        previous
      );
    }
  };

  const goNextMonth = () => {
    setCurrentMonth(
      new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth() + 1,
        1
      )
    );
  };

  /* =========================
     SELECT DATE
  ========================= */

  const handleDateSelect = (date) => {
    if (
      !date ||
      isPastDate(date) ||
      isWeekend(date)
    ) {
      return;
    }

    setSelectedDate(
      formatDateValue(date)
    );

    setSelectedSlot(null);
    setAvailableSlots([]);
    setError("");
  };

  /* =========================
     API - AVAILABLE SLOTS
  ========================= */

  useEffect(() => {
    if (!selectedDate) return;

    let cancelled = false;

    const fetchSlots = async () => {
      try {
        setLoadingSlots(true);
        setError("");
        setAvailableSlots([]);
        setSelectedSlot(null);

        const response =
          await fetch(
            `${API_BASE_URL}/discovery-call/available-slots?date=${encodeURIComponent(
              selectedDate
            )}`,
            {
              method: "GET",
              headers: {
                Accept:
                  "application/json"
              }
            }
          );

        const data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            data.message ||
              "Failed to load available times."
          );
        }

        if (
          !Array.isArray(
            data.availableSlots
          )
        ) {
          throw new Error(
            "Invalid slots response."
          );
        }

        if (!cancelled) {
          setAvailableSlots(
            data.availableSlots
          );
        }
      } catch (err) {
        if (cancelled) return;

        console.error(
          "Available slots error:",
          err
        );

        setAvailableSlots([]);

        setError(
          err.message ||
            "Unable to load available times."
        );
      } finally {
        if (!cancelled) {
          setLoadingSlots(false);
        }
      }
    };

    fetchSlots();

    return () => {
      cancelled = true;
    };
  }, [selectedDate]);

  /* =========================
     RAZORPAY
  ========================= */

  const loadRazorpay = () => {
    return new Promise(
      (resolve) => {
        if (window.Razorpay) {
          resolve(true);
          return;
        }

        const existing =
          document.querySelector(
            'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
          );

        if (existing) {
          existing.onload = () =>
            resolve(true);

          existing.onerror = () =>
            resolve(false);

          return;
        }

        const script =
          document.createElement(
            "script"
          );

        script.src =
          "https://checkout.razorpay.com/v1/checkout.js";

        script.async = true;

        script.onload = () =>
          resolve(true);

        script.onerror = () =>
          resolve(false);

        document.body.appendChild(
          script
        );
      }
    );
  };

  /* =========================
     BOOKING
  ========================= */

  const handleBooking = async (e) => {
    e.preventDefault();

    setError("");

    if (!selectedDate) {
      setError(
        "Please select a date."
      );
      return;
    }

    if (!selectedSlot) {
      setError(
        "Please select a time."
      );
      return;
    }

    if (!name.trim()) {
      setError(
        "Please enter your name."
      );
      return;
    }

    if (!email.trim()) {
      setError(
        "Please enter your email."
      );
      return;
    }

    if (!phone.trim()) {
      setError(
        "Please enter your phone number."
      );
      return;
    }

    try {
      setLoadingPayment(true);

      /* HOLD SLOT */

      const holdResponse =
        await fetch(
          `${API_BASE_URL}/discovery-call/hold-slot`,
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",

              Accept:
                "application/json"
            },

            body:
              JSON.stringify({
                name:
                  name.trim(),

                email:
                  email
                    .trim()
                    .toLowerCase(),

                phone:
                  phone.trim(),

                bookingDate:
                  selectedDate,

                startTime:
                  selectedSlot.startTime,

                endTime:
                  selectedSlot.endTime
              })
          }
        );

      const holdData =
        await holdResponse.json();

      if (!holdResponse.ok) {
        throw new Error(
          holdData.message ||
            "This slot is no longer available."
        );
      }

      const bookingId =
        holdData.bookingId;

      /* CREATE ORDER */

      const orderResponse =
        await fetch(
          `${API_BASE_URL}/discovery-call/create-order`,
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",

              Accept:
                "application/json"
            },

            body:
              JSON.stringify({
                bookingId
              })
          }
        );

      const orderData =
        await orderResponse.json();

      if (!orderResponse.ok) {
        throw new Error(
          orderData.message ||
            "Unable to create payment order."
        );
      }

      /* RAZORPAY */

      const razorpayLoaded =
        await loadRazorpay();

      if (!razorpayLoaded) {
        throw new Error(
          "Razorpay could not be loaded."
        );
      }

      const options = {
        key:
          orderData.keyId,

        amount:
          orderData.amount,

        currency:
          orderData.currency,

        name:
          "ForgeYourPeak",

        description:
          "15-Minute Discovery Call",

        order_id:
          orderData.orderId,

        prefill: {
          name:
            name.trim(),

          email:
            email
              .trim()
              .toLowerCase(),

          contact:
            phone.trim()
        },

        notes: {
          bookingId:
            String(bookingId)
        },

        theme: {
          color:
            "#5d5cf6"
        },

        handler:
          async function (
            razorpayResponse
          ) {
            try {
              const verifyResponse =
                await fetch(
                  `${API_BASE_URL}/discovery-call/verify-payment`,
                  {
                    method:
                      "POST",

                    headers: {
                      "Content-Type":
                        "application/json",

                      Accept:
                        "application/json"
                    },

                    body:
                      JSON.stringify({
                        bookingId,

                        razorpay_order_id:
                          razorpayResponse.razorpay_order_id,

                        razorpay_payment_id:
                          razorpayResponse.razorpay_payment_id,

                        razorpay_signature:
                          razorpayResponse.razorpay_signature
                      })
                  }
                );

              const verifyData =
                await verifyResponse.json();

              if (
                !verifyResponse.ok
              ) {
                throw new Error(
                  verifyData.message ||
                    "Payment verification failed."
                );
              }

              setSuccess(true);
              setError("");
            } catch (verifyError) {
              console.error(
                "Payment verification error:",
                verifyError
              );

              setError(
                verifyError.message ||
                  "Payment verification failed."
              );
            } finally {
              setLoadingPayment(false);
            }
          },

        modal: {
          ondismiss: () => {
            setLoadingPayment(false);
          }
        }
      };

      const razorpay =
        new window.Razorpay(
          options
        );

      razorpay.on(
        "payment.failed",
        () => {
          setError(
            "Payment failed. Please try again."
          );

          setLoadingPayment(false);
        }
      );

      razorpay.open();
    } catch (err) {
      console.error(
        "Discovery booking error:",
        err
      );

      setError(
        err.message ||
          "Something went wrong."
      );

      setLoadingPayment(false);
    }
  };

  /* =========================
     SUCCESS
  ========================= */

  if (success) {
    return (
      <div className="discovery-page">

        <div className="discovery-layout">

          <aside className="discovery-left">

            <div className="brand">
              <div className="brand-mark">
                F
              </div>

              ForgeYourPeak
            </div>

            <div className="left-content">

              <span className="eyebrow">
                PERSONAL GROWTH · REAL PROGRESS.
              </span>

              <h1>
                Let's build a
                <br />

                <span>
                  better you.
                </span>
              </h1>

              <p>
                A focused 15-minute conversation
                to understand where you are,
                where you want to go, and how
                ForgeYourPeak can help you get there.
              </p>

              <LeftBenefits />

              <div className="left-price">
                ₹49
                <span>
                  / session
                </span>
              </div>

            </div>

            <div className="left-footer">
              🔒 Secure booking · India Standard Time
            </div>

          </aside>


          <main className="discovery-right success-page">

            <div className="success-icon">
              ✓
            </div>

            <span className="success-eyebrow">
              BOOKING CONFIRMED
            </span>

            <h2>
              You're all set!
            </h2>

            <p className="success-subtitle">
              Your 15-minute Discovery Call
              has been successfully booked.
            </p>

            <div className="success-card">

              <div className="success-row">
                <span>
                  📅
                </span>

                <div>
                  <small>
                    Date
                  </small>

                  <strong>
                    {formatSelectedDate()}
                  </strong>
                </div>
              </div>

              <div className="success-row">
                <span>
                  ◷
                </span>

                <div>
                  <small>
                    Time
                  </small>

                  <strong>
                    {selectedSlot?.startTime}
                    {" – "}
                    {selectedSlot?.endTime}
                    {" "}
                    (IST)
                  </strong>
                </div>
              </div>

              <div className="success-row">
                <span>
                  👤
                </span>

                <div>
                  <small>
                    Name
                  </small>

                  <strong>
                    {name}
                  </strong>
                </div>
              </div>

              <div className="success-row">
                <span>
                  ✉
                </span>

                <div>
                  <small>
                    Email
                  </small>

                  <strong>
                    {email}
                  </strong>
                </div>
              </div>

              <div className="success-row">
                <span>
                  ₹
                </span>

                <div>
                  <small>
                    Payment
                  </small>

                  <strong>
                    ₹49 Paid
                    <em>
                      Success
                    </em>
                  </strong>
                </div>
              </div>

            </div>

            <div className="meeting-notice">

              <strong>
                Meeting link coming soon!
              </strong>

              <p>
                Your meeting link will be sent
                to <b>{email}</b> 1 hour before
                your scheduled call.
              </p>

            </div>

          </main>

        </div>

      </div>
    );
  }

  const calendarDays =
    getCalendarDays();

  /*
   * =========================
   * MAIN
   * =========================
   */

  return (
    <div className="discovery-page">

      <div className="discovery-layout">

        {/* =====================================
            LEFT PANEL
        ===================================== */}

        <aside className="discovery-left">

          <div className="brand">

            <div className="brand-mark">
              F
            </div>

            ForgeYourPeak

          </div>


          <div className="left-content">

            <span className="eyebrow">
              PERSONAL GROWTH · REAL PROGRESS.
            </span>


            <h1>
              Let's build a
              <br />

              <span>
                better you.
              </span>
            </h1>


            <p>
              A focused 15-minute conversation
              to understand where you are,
              where you want to go, and how
              ForgeYourPeak can help you get there.
            </p>


            <LeftBenefits />


            <div className="left-price">
              ₹49
              <span>
                / session
              </span>
            </div>

          </div>


          <div className="left-footer">
            🔒 Secure booking · India Standard Time
          </div>

        </aside>


        {/* =====================================
            RIGHT PANEL
        ===================================== */}

        <main className="discovery-right">


          {!selectedSlot ? (

            <>
              {/* HEADER */}

              <div className="booking-header">

                <div>

                  <span>
                    FORGEYOURPEAK
                  </span>

                  <h2>
                    {selectedDate
                      ? "Choose a Time"
                      : "Book a 15-Minute Discovery Call"}
                  </h2>

                  <p>
                    {selectedDate
                      ? "Select a time that works for you."
                      : "Select a date to see available time slots."}
                  </p>

                </div>


                <div className="steps">

                  <i className="active">
                    1
                  </i>

                  <i>
                    2
                  </i>

                  <i>
                    3
                  </i>

                </div>

              </div>


              <div className="booking-divider" />


              {/* DATE + TIME */}

              <div className="booking-stage">


                {/* CALENDAR */}

                <section className="calendar-panel">

                  <div className="stage-title">

                    <div className="stage-number">
                      01
                    </div>

                    <div>

                      <strong>
                        Choose a date
                      </strong>

                      <small>
                        Select your preferred weekday
                      </small>

                    </div>

                  </div>


                  <div className="calendar-top">

                    <button
                      type="button"
                      onClick={
                        goPreviousMonth
                      }
                    >
                      ‹
                    </button>


                    <strong>
                      {monthTitle}
                    </strong>


                    <button
                      type="button"
                      onClick={
                        goNextMonth
                      }
                    >
                      ›
                    </button>

                  </div>


                  <div className="weekdays">

                    <span>Mon</span>
                    <span>Tue</span>
                    <span>Wed</span>
                    <span>Thu</span>
                    <span>Fri</span>
                    <span>Sat</span>
                    <span>Sun</span>

                  </div>


                  <div className="calendar-grid">

                    {calendarDays.map(
                      (
                        date,
                        index
                      ) => {

                        if (!date) {

                          return (
                            <div
                              key={
                                `empty-${index}`
                              }
                            />
                          );

                        }


                        const disabled = !isBookableDate(date);


                        return (
                          <button
                            key={
                              formatDateValue(
                                date
                              )
                            }
                            type="button"
                            disabled={
                              disabled
                            }
                            className={[
                              "calendar-day",
                              disabled
                                ? "disabled"
                                : "",
                              isSelected(
                                date
                              )
                                ? "selected"
                                : ""
                            ].join(" ")}
                            onClick={() =>
                              handleDateSelect(
                                date
                              )
                            }
                          >
                            {
                              date.getDate()
                            }
                          </button>
                        );

                      }
                    )}

                  </div>


                  <div className="calendar-info">
                    ⓘ
                    <span>
                      We're available Monday to Friday only.
                    </span>
                  </div>

                </section>


                {/* TIME */}

                <section className="time-panel">

                  {!selectedDate ? (

                    <div className="time-placeholder">

                      <div className="placeholder-icon">
                        📅
                      </div>

                      <strong>
                        Select a date
                      </strong>

                      <p>
                        Choose a date from the calendar
                        to view available time slots.
                      </p>

                    </div>

                  ) : (

                    <>

                      <div className="time-header">

                        <span>
                          AVAILABLE TIMES
                        </span>

                        <strong>
                          {formatSelectedDate()}
                        </strong>

                        <small>
                          India Standard Time (IST)
                        </small>

                      </div>


                      {loadingSlots ? (

                        <div className="time-loading">

                          <div className="spinner" />

                          <span>
                            Checking availability...
                          </span>

                        </div>

                      ) : error ? (

                        <div className="time-empty">

                          <div>
                            !
                          </div>

                          <strong>
                            Unable to load times
                          </strong>

                          <p>
                            {error}
                          </p>

                        </div>

                      ) : availableSlots.length === 0 ? (

                        <div className="time-empty">

                          <div>
                            ×
                          </div>

                          <strong>
                            No times available
                          </strong>

                          <p>
                            Please select another weekday.
                          </p>

                        </div>

                      ) : (

                        <div className="time-list">

                          {availableSlots.map(
                            (slot) => (

                              <button
                                key={`${slot.startTime}-${slot.endTime}`}
                                type="button"
                                onClick={() =>
                                  setSelectedSlot(
                                    slot
                                  )
                                }
                              >

                                <div>

                                  <strong>
                                    {slot.startTime}
                                  </strong>

                                  <small>
                                    {slot.endTime}
                                  </small>

                                </div>

                                <span>
                                  →
                                </span>

                              </button>

                            )
                          )}

                        </div>

                      )}

                    </>

                  )}

                </section>

              </div>

            </>

          ) : (

            /* =====================================
               DETAILS PAGE
            ===================================== */

            <>

              <div className="booking-header">

                <div>

                  <button
                    type="button"
                    className="change-time"
                    onClick={() =>
                      setSelectedSlot(null)
                    }
                  >
                    ← Change time
                  </button>

                  <h2>
                    Your Details
                  </h2>

                  <p>
                    Please provide your information
                    to confirm your booking.
                  </p>

                </div>


                <div className="steps">

                  <i className="done">
                    ✓
                  </i>

                  <i className="done">
                    ✓
                  </i>

                  <i className="active">
                    3
                  </i>

                </div>

              </div>


              <div className="booking-divider" />


              {/* SELECTED SLOT */}

              <div className="selected-summary">

                <div>

                  <span>
                    📅
                  </span>

                  <div>

                    <small>
                      DATE
                    </small>

                    <strong>
                      {formatSelectedDate()}
                    </strong>

                  </div>

                </div>


                <div>

                  <span>
                    ◷
                  </span>

                  <div>

                    <small>
                      TIME
                    </small>

                    <strong>
                      {selectedSlot.startTime}
                      {" – "}
                      {selectedSlot.endTime}
                    </strong>

                  </div>

                </div>

              </div>


              {/* FORM */}

              <form
                className="details-form"
                onSubmit={
                  handleBooking
                }
              >

                <div className="form-title">

                  <div className="stage-number">
                    03
                  </div>

                  <div>

                    <strong>
                      Your details
                    </strong>

                    <small>
                      We'll use these for your confirmation
                    </small>

                  </div>

                </div>


                <div className="form-field">

                  <label>
                    FULL NAME
                  </label>

                  <div className="input-wrap">

                    <span>
                      👤
                    </span>

                    <input
                      type="text"
                      placeholder="Enter your full name"
                      value={name}
                      onChange={(e) =>
                        setName(
                          e.target.value
                        )
                      }
                    />

                  </div>

                </div>


                <div className="form-field">

                  <label>
                    EMAIL ADDRESS
                  </label>

                  <div className="input-wrap">

                    <span>
                      ✉
                    </span>

                    <input
                      type="email"
                      placeholder="you@example.com"
                      value={email}
                      onChange={(e) =>
                        setEmail(
                          e.target.value
                        )
                      }
                    />

                  </div>

                </div>


                <div className="form-field">

                  <label>
                    PHONE NUMBER
                  </label>

                  <div className="input-wrap">

                    <span>
                      ☎
                    </span>

                    <input
                      type="tel"
                      placeholder="Enter your phone number"
                      value={phone}
                      onChange={(e) =>
                        setPhone(
                          e.target.value
                        )
                      }
                    />

                  </div>

                </div>


                {error && (

                  <div className="form-error">
                    !
                    <span>
                      {error}
                    </span>
                  </div>

                )}


                <div className="payment-row">

                  <div>

                    <small>
                      DISCOVERY CALL
                    </small>

                    <strong>
                      ₹49
                    </strong>

                  </div>


                  <button
                    type="submit"
                    className="pay-button"
                    disabled={
                      loadingPayment
                    }
                  >

                    {loadingPayment ? (

                      <>
                        <span className="spinner-small" />
                        Processing...
                      </>

                    ) : (

                      <>
                        Pay ₹49 & Book My Call
                        <span>
                          →
                        </span>
                      </>

                    )}

                  </button>

                </div>


                <div className="secure-text">
                  🔒 Secure payment powered by Razorpay
                </div>


                <p className="confirmation-note">
                  You'll receive a confirmation email
                  with your booking details after payment.
                </p>

              </form>

            </>

          )}

        </main>

      </div>

    </div>
  );
};


/* =========================================
   LEFT BENEFITS
========================================= */

const LeftBenefits = () => {
  return (
    <div className="left-benefits">

      <div className="left-benefit">

        <div className="benefit-icon">
          ◷
        </div>

        <div>

          <strong>
            15 minutes
          </strong>

          <small>
            Focused & Effective
          </small>

        </div>

      </div>


      <div className="left-benefit">

        <div className="benefit-icon">
          ●
        </div>

        <div>

          <strong>
            Personalised guidance
          </strong>

          <small>
            Tailored to your goals
          </small>

        </div>

      </div>


      <div className="left-benefit">

        <div className="benefit-icon">
          ▮
        </div>

        <div>

          <strong>
            Clear next steps
          </strong>

          <small>
            Actionable roadmap
          </small>

        </div>

      </div>


      <div className="left-benefit">

        <div className="benefit-icon">
          ✓
        </div>

        <div>

          <strong>
            No long commitment
          </strong>

          <small>
            Just one conversation
          </small>

        </div>

      </div>

    </div>
  );
};


export default DiscoveryCallBooking;